import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n';
import ContextAllPost from './AllPostContext';
import ContextPost from './PostContext';
import ContextLocation from './LocationContext';
import NotificationProvider from './NotificationContext';
import OfferProvider from './OfferContext';
import WatchlistProvider from './WatchlistContext';
import ContextChat from './ChatContext';
import { ToastProvider } from './ToastContext';

function AppProviders({ children }) {
  return (
    <I18nextProvider i18n={i18n}>
      <NotificationProvider>
        <OfferProvider>
          <WatchlistProvider>
            <ContextChat>
              <ContextAllPost>
                <ContextPost>
                  <ContextLocation>
                    <ToastProvider>{children}</ToastProvider>
                  </ContextLocation>
                </ContextPost>
              </ContextAllPost>
            </ContextChat>
          </WatchlistProvider>
        </OfferProvider>
      </NotificationProvider>
    </I18nextProvider>
  );
}

export default AppProviders;
